const React = require('react');
const style = require('../game.style').default;
const { StageClearContainer, GamePauseContainer, GameOverContainer, GameClearContainer, StageStartContainer, StageScenarioContainer, ResultContainer }
    = require('../modal').default;
const gameParamater = require('../../../define/gameParamater').default;
const object = require('../../../define/object').default;
const SelectorComponent = require('./selectorComponent').default;
const BoardComponent = require('./boardComponent').default;
const InformationComponent = require('./informationComponent').default;
const assets = require('../../../assets').default;
const { getClearStageScenario, getStageBonus, isSubjugation, stageScenario } = require('../../../core/stageData').default;
const timer = require('../../../core/timer').default;
const { stageGimmick } = require('../../../core/stageData').default;
const { sound, soundType } = require('../../../core/sound').default;
// ============================

export default class gameComponent extends React.Component {
    componentDidMount() {
        this.props.onGameMount();
        this.interval = setInterval(this.forceUpdate.bind(this), this.props.updateInterval || 33);
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    renderLoadImage() {
        return (
            <>
                <img src={assets.ObjectPorinRed} style={style.loadImage} />
                <img src={assets.ObjectPorinBlue} style={style.loadImage} />
                <img src={assets.ObjectPorinGreen} style={style.loadImage} />
                <img src={assets.ObjectPorinYellow} style={style.loadImage} />
                <img src={assets.ObjectMobElvira} style={style.loadImage} />
                <img src={assets.ObjectMobRudo} style={style.loadImage} />
                <img src={assets.ObjectMobSeohyun} style={style.loadImage} />
                <img src={assets.ObjectMobLola} style={style.loadImage} />
                <img src={assets.ObjectMobNightMare} style={style.loadImage} />
                <img src={assets.ObjectMobGarm} style={style.loadImage} />
                <img src={assets.ObjectMobGryphon} style={style.loadImage} />
                <img src={assets.ObjectMobZilant} style={style.loadImage} />
            </>
        )
    }

    renderInformation() {
        const { soundEnable } = this.props.appState;
        const { baseTime, startedAt, stoppedAt } = this.props.gameState;
        const elapsedTime = timer.getElapsedTime(baseTime, startedAt, stoppedAt);
        let remainingTime = gameParamater.REMAINING_TIME - (elapsedTime / 1000);
        if (remainingTime < 0) {
            remainingTime = 0;
            if (this.props.gameState.isGamePlaying) {
                sound.playSound(soundType.SE_GAME_OVER, soundEnable);
                this.props.onTimeOver();
            }
        }
        return (
            <div style={style.informationStyle}>
                <InformationComponent
                    gameState={this.props.gameState}
                    playerState={this.props.playerState}
                    time={Math.floor(remainingTime)}
                    soundEnable={soundEnable}
                    onPauseClick={() => {
                        sound.playSound(soundType.SE_SELECT_SYSTEM, soundEnable);
                        this.props.onPause()
                    }}
                    onSoundClick={() => {
                        sound.playSound(soundType.SE_SELECT_SYSTEM, !soundEnable);
                        this.props.toggleSound()
                    }} />
            </div>
        )
    }

    renderSelector() {
        const { selectorState = {}, playerState = {}, appState = {} } = this.props;
        const { baseTime, startedAt, stoppedAt, playerSkillCoolTime, canSkill } = playerState;
        let remainingTime = 0;
        if (!canSkill) {
            const elapsedTime = timer.getElapsedTime(baseTime, startedAt, stoppedAt);
            remainingTime = playerSkillCoolTime - (elapsedTime / 1000);
            if (remainingTime < 0) {
                remainingTime = 0;
                this.props.onSkillCoolTimeEnd();
            }
        }
        return (
            <div style={style.selectorStyle}>
                <SelectorComponent
                    selectorState={selectorState}
                    playerState={playerState}
                    onClickSelector={index => {
                        sound.playSound(soundType.SE_SELECT_PORIN, appState.soundEnable);
                        this.props.onClickSelector(index)
                    }}
                    skillRemainingTime={remainingTime} />
            </div>
        )
    }

    deleteWithGimmick(posX, posY, gimmickNo) {
        const { gameState } = this.props;
        switch (gameState.gimmick) {
            case stageGimmick.GIMMICK_BEAST:
                if (gimmickNo !== undefined && gimmickNo !== gameState.gimmickNo) {
                    this.props.onChangeItem(posX, posY, object.OBJ_IMMORTAL_CLYSTAL, 1, 0);
                    return;
                }
                break;
            default:
                break;
        }
        this.props.onDeleteItem(posX, posY);
        return;
    }

    renderBoard() {
        const { boardState, gameState, appState } = this.props;

        return (
            <div style={style.boardStyle}>
                <BoardComponent
                    soundEnable={appState.soundEnable}
                    state={boardState}
                    isGamePlaying={gameState.isGamePlaying}
                    isSubjugation={isSubjugation(gameState.arrivalStage)}
                    updateInterval={250}
                    addScore={(point) => this.props.addScore(point)}
                    onDropItem={(array, frameId) => {
                        sound.playSound(soundType.SE_PUT_PORIN, appState.soundEnable)
                        this.props.onDropPorinBox(array, frameId)
                    }}
                    onDropSkill={array => this.props.onDropSkill(array)}
                    onDeleteItem={(posX, posY, gimmickNo) => this.deleteWithGimmick(posX, posY, gimmickNo)}
                    onBreakTreasure={() => this.props.onBreakTreasure()}
                    onClearStage={() => {
                        sound.playSound(soundType.SE_STAGE_CLEAR, appState.soundEnable);
                        getClearStageScenario(gameState.arrivalStage) === stageScenario.SCENARIO_ENDING
                            ? this.props.onClearGame()
                            : this.props.onClearStage(getStageBonus(gameState.arrivalStage))
                    }}
                    onChainDamage={array => this.props.onChainDamage(array)}
                />
            </div>
        )
    }

    renderModal() {
        return (
            <div>
                <ResultContainer />
                <StageScenarioContainer />
                <StageStartContainer />
                <GamePauseContainer />
                <StageClearContainer />
                <GameOverContainer />
                <GameClearContainer />
            </div>
        )
    }

    render() {
        return <div style={style.gameAreaStyle}>
            {this.renderModal()}
            {this.renderInformation()}
            {this.renderBoard()}
            {this.renderSelector()}
            {this.renderLoadImage()}
        </div>
    }
}